import { render, staticRenderFns } from "./FTPCredentialForm.vue?vue&type=template&id=1ed84c33&"
import script from "./FTPCredentialForm.vue?vue&type=script&lang=js&"
export * from "./FTPCredentialForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ed84c33')) {
      api.createRecord('1ed84c33', component.options)
    } else {
      api.reload('1ed84c33', component.options)
    }
    module.hot.accept("./FTPCredentialForm.vue?vue&type=template&id=1ed84c33&", function () {
      api.rerender('1ed84c33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/FTP/FTPCredentialForm.vue"
export default component.exports